import React from 'react';
import PropTypes from 'prop-types';
import { PlanLoaderProgress } from '../PlanLoaderProgress';

const DELAY = 800;

function PlanLoaderSlide({ onContinue, steps, stats }) {
    const finishProgress = () => {
        setTimeout(() => {
            onContinue();
        }, DELAY);
    };

    return (
        <PlanLoaderProgress finish={finishProgress} steps={steps} stats={stats} />
    );
}

PlanLoaderSlide.propTypes = {
    onContinue: PropTypes.func.isRequired,
    steps: PropTypes.arrayOf(PropTypes.string),
    stats: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        percent: PropTypes.string,
        description: PropTypes.node,
        highlight: PropTypes.node
    }))
};

export {
    PlanLoaderSlide
};
